<template>
    <section class="also__like__container">
        <div class="wrapper__texts">
            <div class="low__text">German Machines</div>
            <div class="text">You may also like</div>
            <router-link :to="{ name: 'ugm-machines' }">
                View all
                <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.74 4.42L9.02 0.81L9.86 0L14.58 4.59L15 5L14.58 5.4L9.86 10L9.02 9.18L12.74 5.57L0 5.57L0 4.42L12.74 4.42Z" fill="#050505" fill-rule="evenodd"/>
                </svg>
            </router-link>
        </div>
        <UgmMachineList :itemsPerRow="4" :products="products"></UgmMachineList>
    </section>
</template>

<script>
import UgmMachineList from './UgmMachineList.vue';
export default {
    components: {
        UgmMachineList,
    },
    props: {
        products: { type: Array, required: true },
    },
}
</script>

<style scoped>
.also__like__container{
    padding-bottom: 120px;
    padding-top: 80px;
}
.wrapper__texts{
    position: relative;
    margin-bottom: 64px;
}
.wrapper__texts .low__text{
    color: rgb(85, 98, 114);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    padding-bottom: 10px;
}
.wrapper__texts .text{
    color: rgb(5, 5, 5);
    font-size: 44px;
    font-weight: 500;
    line-height: 140%;
    max-width: 555px;
}
.wrapper__texts a{
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
}
@media (max-width: 1024px) {
    .wrapper__texts a{
        bottom: unset;
        top: 0;
    }
    .wrapper__texts{
        margin-bottom: 24px;
    }
    .wrapper__texts .text{
        font-size: 32px;
        max-width: 100%;
    }
}
@media (max-width: 768px) {
    .wrapper__texts .text{
        font-size: 24px;
    }
}
</style>
